import { useCallback } from 'react';

import { CurrencyFormatter, CurrencyFormatterOptions } from '../formatters/CurrencyFormatter';
import { useHideCurrency } from '../store/compositeSelectors/useHideCurrency';
import { useGameStateSlice } from '../store/slices/game/selectors';
import { useSettingsSlice } from '../store/slices/settings/selectors';

export const useCurrencyFormatterConnected = (
  options?: Omit<CurrencyFormatterOptions, 'currency'>
): ((value: number) => string | null) => {
  const currency = useGameStateSlice.getCurrency();
  const currentLanguage = useSettingsSlice.currentLanguage();

  const hideCurrency = useHideCurrency();

  return useCallback(
    (value) => {
      if (!currency) return null;
      return CurrencyFormatter.format(value, currentLanguage, { ...options, currency, hideCurrency });
    },
    //TODO: review dependencies
    [currency, hideCurrency, options]
  );
};
